import { render, staticRenderFns } from "./consumptionList.vue?vue&type=template&id=244a4e93&scoped=true"
import script from "./consumptionList.vue?vue&type=script&lang=js"
export * from "./consumptionList.vue?vue&type=script&lang=js"
import style0 from "./consumptionList.vue?vue&type=style&index=0&id=244a4e93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a4e93",
  null
  
)

export default component.exports